import BaseService from "./BaseService";

const endpoint = 'suppliers'

class SupplierService {
    static async GetSuppliers(token, params) {
        try {
            if (params) {
                return await BaseService.get(endpoint, token, params);
            }
            return await BaseService.get(endpoint, token);
        } catch (error) {
            console.error("Erro ao buscar fornecedores!", error);
            throw error;
        }
    }

}

export default SupplierService;